import { Box, Typography } from '@mui/material';
import ResponsiveEllipsisTitle from '../ResponsiveEllipsisTitle';

const PageHead = ({ primary, secondary, back }: { primary: React.ReactNode | string, secondary?: React.ReactNode | string | null, back?: React.ReactNode | string }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', gap: 2, p:1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: secondary === '' ? 0 : 1 }}>
                {back && <Box sx={{ display: 'flex', alignItems: 'center' }}>{back}</Box>}
                {typeof primary === 'string' ? (
                    <ResponsiveEllipsisTitle title={primary} />
                ) : (
                    primary
                )}
            </Box>
            <Box sx={{ py: '5px' }} display={'flex'} justifyContent={'space-between'} alignItems={'center'} gap={1}>
                {secondary && (typeof secondary === 'string' ? (
                    <Typography variant="h5">{secondary}</Typography>
                ) : (
                    secondary
                ))}
            </Box>
        </Box>
    );
};

export default PageHead;
